import { useEffect, useState } from 'react';
import './Footer.scss';
import { FetchData } from '../../utils/FetchData'

export function Footer () {
    const [contratacion, setContratacion] = useState<Array<any>>([]);
    const [redes, setRedes] = useState<any>();

    const fetchContactData = () => {
        FetchData('contact/data').
         then((data) => {
            setContratacion(data.response.contratacion);
            setRedes(data.response.redes);
        }).catch((e) => console.error(e));
    }
  
    useEffect(() => {
        fetchContactData();
    }, []);

    return (
        <footer className="to-rows-mobile">
            <address>
                <h3>Manager y contratación</h3>
                { contratacion.map((linea, index) => (
                    <span key={index}>{ linea.indexOf('@') !== -1 ? <a href={`mailto:${linea}`}>{linea}</a> :  linea }</span>
                )) }
                <a href="http://farashaproducciones.net">
                    <img src="assets/farasha.png" alt="Logo Farasha Producciones" />
                </a>
            </address>

            <div className="social">
                <h3>Redes</h3>
                <ul>
                    { redes && Object.keys(redes).map((red, index) => (
                        <li key={index}><a href={redes[red]}><i className={`fab fa-${red}`}></i></a></li>
                    ))}
                </ul>
            </div>
        </footer>
    );

}